import { Footer } from "@nju/feature-portal-footer";
import { DocumentsList } from "@nju/feature-sales-dashboard";
import { Header, HeaderBackgroundWrapper } from "@nju/feature-sales-header";
import { BlockContent, LayoutWrapper } from "@nju/ui";

export default function InstructionsOffers() {
  return (
    <LayoutWrapper>
      <HeaderBackgroundWrapper>
        <Header />
      </HeaderBackgroundWrapper>
      <BlockContent spacing="l">
        <DocumentsList />
      </BlockContent>
      <Footer />
    </LayoutWrapper>
  );
}
